// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsBeamMode_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 0H14V3.99786L16 5.9968 18 3.99786V0ZM18 21.9883 16.1667 10.9941H18L16 6.99626 14 10.9941H15.8333L14 21.9883 16 23.9872 18 21.9883Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3569 31.1216C12.9253 31.7072 13.6606 32 14.563 32C15.4888 32 16.2388 31.6969 16.813 31.0908C17.3901 30.4847 17.6787 29.6868 17.6787 28.6971C17.6787 27.7337 17.4004 26.9578 16.8438 26.3692C16.29 25.7807 15.5635 25.4864 14.6641 25.4864C13.7119 25.4864 12.9473 25.7938 12.3701 26.4087C11.793 27.0237 11.5044 27.8289 11.5044 28.8244C11.5044 29.7673 11.7886 30.533 12.3569 31.1216ZM13.438 27.2696C13.731 26.8948 14.1265 26.7074 14.6245 26.7074C15.1079 26.7074 15.4888 26.889 15.7671 27.252C16.0454 27.6151 16.1846 28.1232 16.1846 28.7761C16.1846 29.4028 16.041 29.8932 15.7539 30.2475C15.4668 30.5989 15.0786 30.7746 14.5894 30.7746C14.1147 30.7746 13.731 30.593 13.438 30.2299C13.145 29.8669 12.9985 29.3735 12.9985 28.7498C12.9985 28.1349 13.145 27.6415 13.438 27.2696Z" class="svg-bg"/>
  <path d="M9.06543 31.9829H10.4673V25.6845H8.44141L7.15381 29.4091C7.06592 29.6668 6.98242 29.9698 6.90332 30.3183H6.87695C6.83008 30.0167 6.75537 29.7166 6.65283 29.4179L5.36523 25.6845H3.28662V31.9829H4.56543V28.4999C4.56543 28.0314 4.54639 27.4868 4.5083 26.866H4.54785C4.63867 27.3375 4.70459 27.6303 4.74561 27.7445L6.24854 31.9829H7.40869L8.88525 27.7005C8.94385 27.5307 9.00977 27.2525 9.08301 26.866H9.11816C9.08301 27.3579 9.06543 27.8074 9.06543 28.2144V31.9829Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6362 31.9829V25.6845H20.8687C23.1069 25.6845 24.2261 26.7079 24.2261 28.7547C24.2261 29.7356 23.9199 30.5189 23.3076 31.1045C22.6982 31.6901 21.8853 31.9829 20.8687 31.9829H18.6362ZM20.0557 26.8397V30.8322H20.7588C21.374 30.8322 21.856 30.6477 22.2046 30.2788C22.5562 29.9098 22.7319 29.4076 22.7319 28.7722C22.7319 28.172 22.5576 27.7005 22.209 27.3579C21.8633 27.0124 21.377 26.8397 20.75 26.8397H20.0557Z" class="svg-bg"/>
  <path d="M25.3647 31.9829H29.144V30.8322H26.7842V29.3915H28.8452V28.2408H26.7842V26.8397H28.999V25.6845H25.3647V31.9829Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsBeamMode is a generated icon component.
 */
let IconRmsBeamMode = IconRmsBeamMode_1 = class IconRmsBeamMode extends IconBaseElement {
    render() {
        return html `${IconRmsBeamMode_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsBeamMode.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsBeamMode = IconRmsBeamMode_1 = __decorate([
    customElement('zui-icon-rms-beam-mode')
], IconRmsBeamMode);
export { IconRmsBeamMode };
